import CommonStyles from 'shared/style/commonPageStyles'

const Style = {
	Wrapper: CommonStyles.PageWrapper,
	AreaDiv: CommonStyles.AreaDivWithHeader,

	ImgUploadDiv: CommonStyles.ImgUploadDiv,
	ImgElement: CommonStyles.ImgElement,
}

export default Style
